<template>
  <div>
    <!--头部-->
    <Header :showValue="1"></Header>
    <div class="jqgk" style="background: rgb(227 227 227 / 84%)">
      <div class="contai" style="max-width: 1197px;background:white;padding-left:40px;padding-right:40px;margin-bottom: 40px">
        <div class="" style="padding-top:20px">
          <div  v-if="pcshow" style="height:66px;margin-top:5px">
            <div class="titleShuXian" ></div>
            <span class="titleFont" >{{china}}</span>
            <span class="titleFontEnglish" >{{english}}</span>
          </div>

          <div  v-if="!pcshow" style="height:35px;flex-direction:row ;display:flex;color:#840207">
            <span style="font-size:18px">{{china}}</span>
            <span style="font-size:12px;margin-left:5px">{{english}}</span>
          </div>

          <div v-if="pcshow"  style="text-align: left; margin-top: 30px;">
            <div v-for="item in dataList" :key="item.id">

              <!-- <div v-if="item.type == 2" style="flex-direction:row;display:flex">
                <p class="titleFontp next-center">西樵山位于广东省佛山市南海区的西南部，是广东四大名山之一，自然风光清幽秀丽，旅游文化底蕴厚重，民俗风情古朴自然。自明清以来，文人雅士，群贤毕至，旅人游子，纷至沓来，使秀美的西樵山成为名噪南粤的旅游热点。西樵山自然风光美仑美奂，山上七十二峰峰峰皆奇，四十二洞洞洞皆幽，更有湖、瀑、泉、涧、岩、壁、潭、台点缀其间，成为这座熄灭了亿万年的死火山的旷世佳作。西樵山林深苔厚，郁郁葱葱，洞壁岩缝，储水丰富，古人赞之为“谁信匡庐千嶂瀑，移来一半在西樵”。今人称之是：“绿色水库”，“固体水库”。</p>
                <img :src="item.content" style="padding-bottom:20px;width:60%;height:420px" />
              </div> -->

              <div v-if="item.type == 2 " style="flex-direction:row;display:flex">
                <p class="titleFontp next-center">{{topdesc}}</p>
                <img v-if="item.type == 2" :src="item.content" style="padding-bottom:20px;width:60%;height:490px" />
                <!-- 420px -->
              </div>

              <div v-if="item.type == 1" >
                <p class="titleFontp next-center">{{ item.content }}</p>
              </div>
            </div>
          </div>

          <div v-if="!pcshow"  style="text-align: left; margin-top: 0px;flex-direction:column ;display:flex;font-size:14px">
            <div v-for="item in dataList" :key="item.id">
              <div v-if="item.type == 2" style="flex-direction:row;display:flex">
                <img :src="item.content" style="padding-bottom:10px;width:100%;height:20vh" />
              </div>
              <div v-if="item.type == 1" >
                <p class="titleFontpforPhone next-center">{{ item.content }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getGK, getZJXQSList } from '@/api/public'
import Header from './header'
import Footer from './footer'
export default {
  components: { Header, Footer },
  data () {
    return {
      dataListType1: [],
      dataListType2: [],
      topdesc: '',
      datamodal: {},
      dataList: [],
      dataListpc: [],
      pcshow: false,
      china: '',
      english: ''
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
    getGK().then(response => {
      this.dataList = JSON.parse(response.data[0].details)
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].type === 1) {
          this.dataList[i].type = 3
          this.topdesc = this.dataList[i].content
          break
        }
      }
    })
    getZJXQSList().then(response => {
      var linshilist = response.data.sort(this.compare('sort'))
      this.china = linshilist[0].title
      this.english = linshilist[0].enTitle
    })
  },

  mounted () {

  },

  methods: {
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  }
}
</script>

<style>
.smallTitle {
  font-size: 19px !important;
  font-weight: 600 !important;
  width: 100%;
  color: rgb(227 227 227 / 84%) !important;
  text-indent: 2em;
  padding: 0 !important;
}
.widAll {
  width: 100%;
  padding-left: 0px !important;
  font-size: 30px !important;
}
.next-top {
  margin: 40px auto 0 !important;
}
.next-center {
  margin: 0 auto !important;
}
.next-buttom {
  margin: 0 auto 40px !important;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleShuXianForPhone {
  height: 28px;
  margin-top: 14px;
  width: 4px;
  background-color: #840207;
  float: left;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.titleFontEnglishForPhone {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 0px;
  padding-bottom: 15px;
}
.titleFont {
  z-index: 999 !important;
  font-size: 33px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.titleFontpforPhone{
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #2c3030;
  line-height: 30px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
  /* position: absolute; */
}
.titleFontp {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #2c3030;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
  /* position: absolute; */
}

.titleFontForP {
  font-size: 16px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #2c3030;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
  /* position: absolute; */
}
</style>



// WEBPACK FOOTER //
// src/components/outline.vue